import * as React from 'react';
import { SVGProps } from 'react';

const IconRoubleSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.728 4.412H7.77V7.5h.945c1.008 0 1.684-.532 1.684-1.55s-.676-1.538-1.672-1.538z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm4.2-9.1c0 2-1.507 3-3.2 3H7.771V10H11v1H7.771v2H6v-2H4.5v-1H6V8.9H4.5V7.5H6V3h3c1.658 0 3.2.9 3.2 2.9z"
    />
  </svg>
);
export default IconRoubleSizeS;
